<iframe 
    width="100%" 
    height="100%" 
    src="https://veoliasarp.cloud.looker.com/embed/dashboards/45?allow_login_screen=true" 
    frameborder="0" 
    style="border:0" 
    allowfullscreen
    title="DataStudio reporting">
</iframe>